import styled from 'styled-components';
import { alpha, getToken } from '@optimus-web/core';
import { BreakpointRange } from '@mews-commander/ui';

const OPACITY = 0.08;

interface SizedContainerProps {
    width: number;
}
export const Container = styled.div`
    background-color: ${({ theme }) => alpha(getToken('paletteBrandIndigo500')({ theme }), OPACITY)};
    border-radius: ${getToken('borderRadius50')}px;
`;

const breakpointWidthMap = {
    [BreakpointRange.Tablet.name]: 264,
    [BreakpointRange.Desktop.name]: 360,
    [BreakpointRange.LargeDesktop.name]: 440,
};

const SizedContainer = styled.div<SizedContainerProps>`
    width: ${(props) => props.width}px;
`;

export const SizedContainerMap: Record<string, React.FC<React.PropsWithChildren<{}>>> = {
    [BreakpointRange.Tablet.name]: (props) => (
        <SizedContainer width={breakpointWidthMap[BreakpointRange.Tablet.name]} {...props} />
    ),
    [BreakpointRange.Desktop.name]: (props) => (
        <SizedContainer width={breakpointWidthMap[BreakpointRange.Desktop.name]} {...props} />
    ),
    [BreakpointRange.LargeDesktop.name]: (props) => (
        <SizedContainer width={breakpointWidthMap[BreakpointRange.LargeDesktop.name]} {...props} />
    ),
};
